import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './settings-header.scss';

type SettingsHeaderProps = {
	title: string;
	onClickSave: () => void;
};

export const SettingsHeader: React.FC<SettingsHeaderProps> = ({ title, onClickSave }) => {
	const { t } = useTranslation();

	return (
		<div className='settings-header'>
			<h1>{title}</h1>
			<Button type='primary' onClick={onClickSave}>
				{t('common.save')}
			</Button>
		</div>
	);
};
